import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import info from '../info';

export default function Info({ id, extra, customSize }) {
	const content = id && info[id] ? info[id] : '';
	const size = customSize ? customSize : 'tiny';
	return (
		<Popup
			className="info-popup"
			trigger={<Icon className="info-icon" size={size} name="info" circular />}
			content={
				<React.Fragment>
					<span className="info-content">{content}</span>{' '}
					{extra && (
						<React.Fragment>
							<br />
							<br />
							<span className="info-content">{extra}</span>
						</React.Fragment>
					)}
				</React.Fragment>
			}
		/>
	);
}

//style={{ marginTop: '-5px' }}
